export function getEnvironment(): string {
  return (globalThis as any).PINATA_ENV || "development";
}

export function usesHashRouter() {
  return getEnvironment() === "development";
}
